// On phones, "Why kitchens choose us" becomes a one-at-a-time horizontal
// swipe (see .why-us-grid in style.css) — this just keeps the dots below
// it in sync with whichever card is in view.
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".why-us-grid");
  const dots = document.querySelectorAll(".why-us-dot");
  if (!track || !dots.length) return;
  track.addEventListener("scroll", () => {
    const i = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach((d, idx) => d.classList.toggle("nosh-active", idx === i));
  }, { passive: true });
});
